const excludeWords = ['the', 'of', 'as', 'and', 'for', 'or', 'so']

export function capitalizeFirstLetter(word) {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
}

export function capitalizeTitle(string) {
  return string
    .split(' ')
    .map((word) => {
      if (excludeWords.indexOf(word.toLowerCase()) >= 0) return word.toLowerCase()
      return capitalizeFirstLetter(word)
    })
    .join(' ')
}
